<template>
	<div>
		<el-dialog title="导出" :visible.sync="dialogVisible" width="578px" :before-close="handleClose">
			<div class="title">
				请选择要导出的内容
			</div>
			<div class="content">
				<div class="content_item" v-for="(i,ix) in handoverList" :class="{'isItem':isActive==ix}"
					@click="switchHodover(ix)">
					<img src="@/assets/images/组11558@3x.png" alt="">
					<div class="item_text">
						<div>{{i.name}}</div>
						<div>{{i.num}}条数据</div>
					</div>
					<img class="checkImg" v-if="isActive==ix" src="@/assets/images/11639@3x.png" alt="">
				</div>
			</div>
			<span slot="footer">
				<el-button type="primary" class="btn btn-plus" @click="confirm">
					确 定
				</el-button>
				<el-button class="btn " @click="handleClose">
					取 消
				</el-button>
			</span>

		</el-dialog>
		<el-dialog title="导出交接单" :visible.sync="handoverVisible" width="578px" :before-close="handleHandover">
			<div class="confirm_derive">
				<img src="@/assets/images/组10972@3x.png" alt="">
				<div class="text">
					<div>确认要导出当前选中的交接单吗？</div>
					<div>导出有什么问题需要再次确认，说明原因</div>
				</div>
			</div>
			<span slot="footer">
				<el-button type="primary" class="btn btn-plus" @click="confirmDerive">
					确认导出
				</el-button>
				<el-button class="btn " @click="handleHandover">
					取 消
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				handoverVisible: false,
				isActive: null,
				handoverList: [{
						name: '申请名单',
						num: 255
					},
					{
						name: '申请材料接收审查表',
						num: 532
					}, {
						name: '申请材料接收审查表',
						num: 532
					}
				]
			}
		},
		methods: {
			open() {
				this.dialogVisible = true

			},
			handleClose() {
				this.dialogVisible = false
			},
			switchHodover(val) {
				if (val == this.isActive) {
					this.isActive = null
				} else {
					this.isActive = val
				}
			},
			confirm() {
				if (this.isActive >= 0&&this.isActive!=null) {
					this.handoverVisible = true
				}
			},
			confirmDerive() {
				this.dialogVisible = false
				this.handoverVisible = false
			},
			handleHandover() {
				this.handoverVisible = false
			}
		},
	}
</script>
<style lang="scss" scoped>
	/deep/ .el-dialog__header {
		padding: 16px 20px 10px;
		background-color: #f4f6fc;
		height: 50px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__body {
		padding: 30px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__title {
		font-family: Microsoft YaHei;
		font-size: 15px;
		font-weight: bold;
		font-stretch: normal;
		line-height: 20px;
		letter-spacing: 0px;
		color: #24262b;
	}

	/deep/ .el-form-item__label {
		font-family: Microsoft YaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #545454;
	}

	/deep/ .el-form-item {
		margin-bottom: 17px;
	}

	/deep/ .el-dialog__footer {
		padding-top: 0;
	}

	.content {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.content_item {
			width: 252px;
			height: 88px;
			margin-top: 16px;
			background-color: #f5f6fa;
			border-radius: 8px;
			position: relative;
			padding: 24px 20px;
			box-sizing: border-box;
			display: flex;

			img {
				width: 40px;
				height: 40px;
			}

			.item_text {
				margin-left: 14px;

				div:nth-child(1) {
					font-size: 16px;
					line-height: 21px;
					color: #24262b;
				}

				div:nth-child(2) {
					font-size: 12px;
					line-height: 16px;
					color: #9699a0;
				}
			}

			.checkImg {
				position: absolute;
				bottom: 0;
				right: 0;
				width: 38px;
				height: 33px;
			}
		}

		.isItem {
			background-color: #ffffff;
			box-shadow: 0px 8px 8px 0px rgba(0, 58, 194, 0.2);
			border: solid 1px #0147eb;
		}
	}

	.btn {
		height: 40px;
	}

	.btn-plus {
		background-color: #0147eb;
	}

	.btn-bel {
		background-color: #F04444;
	}

	.confirm_derive {
		display: flex;
		align-items: center;

		img {
			width: 88px;
			height: 88px;
			margin-right: 30px;
		}

		.text {
			div:nth-child(1) {
				font-size: 24px;
				line-height: 25px;
				color: #373738;
			}

			div:nth-child(2) {
				font-size: 14px;
				line-height: 40px;
				color: #373738;
			}
		}
	}
</style>
